<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="overview-wrap">
          <h2 class="title-1">Админууд</h2>
          <div v-if="loggedAdmin.role == 0">
            <router-link :to="{name: 'AdminRegister'}" class="mx-5">
              <button class="btn btn-primary">
                <i class="fas fa-plus"></i>
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div v-if="admins !== null" class="card w-100 mt-3">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-top-campaign">
            <tbody>
              <tr v-for="(admin, i) in this.admins" :key="i">
                <td>{{ i + 1 }}</td>
                <td>{{ admin["name"] }}</td>
                <td>{{ admin["role"] == 0 ? "SUPERADMIN" : admin["role"] == 1 ? "Admin" : admin["role"] == 2 ? "Content Manager" : admin["role"] == 3 ? "Banner Manager" : "Unknown" }}</td>
                <td>
                  <router-link
                    v-if="loggedAdmin.id === admin.id"
                    :to="{name: 'AdminPasswordChange', params: {id: admin.id}}"
                  >
                    <button class="btn btn-success btn-sm">
                      <i class="fas fa-key"></i>
                    </button>
                  </router-link>
                  <div v-if="loggedAdmin.role == 0 && loggedAdmin.id !== admin.id">
                    <router-link :to="{name: 'AdminEdit', params: {id: admin.id}}">
                      <button class="btn btn-info btn-sm mx-2">
                        <i class="fas fa-edit"></i>
                      </button>
                    </router-link>
                    <button @click="deleteAdmin(admin.id)" class="btn btn-danger btn-sm">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>
<script>
import AdminService from "@/services/AdminService";
import DeleteDialog from "@/mixins/DeleteDialog.js";

export default {
  name: "AdminsList",

  mixins: [DeleteDialog],

  created() {
    this.$store.dispatch("setLoading", true);
    this.getAdmins();
  },

  data() {
    return {
      admins: null,
      loggedAdmin: this.$store.getters.loggedAdmin
    };
  },

  methods: {
    deletedHandler(id) {
      let index = this.admins.map(admin => admin.id).indexOf(id);
      if (index > -1) this.admins.splice(index, 1);
    },

    deleteAdmin(id) {
      this.confirmDelete(
        id,
        "Админ устгах!",
        "Та энэ админыг устгах уу?",
        AdminService.delete,
        this.deletedHandler
      );
    },

    getAdmins() {
      AdminService.getAdminsList({}).then(response => {
        if (response.status == 200 && response.data.success == true)
          this.admins = response.data.payload;

        this.$store.dispatch("setLoading", false);
      });
    }
  }
};
</script>

<style>
</style>